// DesktopHomepage2.tsx
import React, { useState } from "react";
import "./DesktopHomepage2.css";
import LandingPage from "../../Common/LandingPage/LandingPage";
import Footer from "../../../components/Footer/Footer";
import { useTheme } from "@emotion/react";

const DesktopHomepage2: React.FC = () => {
  const theme: any = useTheme();
  return (
    <div
      className="desktop-homepage"
      style={{ backgroundColor: theme.background }}
    >
      <LandingPage />
      <Footer />
    </div>
  );
};

export default DesktopHomepage2;
